import { memo } from "react";

import { type SelectedOption } from "@shopify/hydrogen-react/storefront-api-types";

import { Text } from "@react/components/Text";
import { type TTailwindString, tw } from "classnames";

const styles = {
  container: tw(
    "flex",
    "flex-row",
    "items-center",
    "justify-between",
    "gap-1.5",
    "text-xs",
    "text-primary-muted"
  ),
  optionText: tw("text-primary-muted"),
  options: tw("flex", "flex-row"),
  item: tw(
    "after:content-['|']" as TTailwindString,
    "after:inline-flex" as TTailwindString,
    "after:mx-1.5" as TTailwindString,
    "last:after:content-['']" as TTailwindString
  ),
};

type Props = {
  selectedOptions: Partial<SelectedOption>[] | undefined;
};

const CartItemSelectedOptionsViewBase = ({ selectedOptions }: Props) => {
  return (
    <div className={styles.container}>
      <Text as="body2" className={styles.optionText} size="xs">
        <>
          {selectedOptions && (
            <span className={styles.options}>
              {selectedOptions.map((option) => (
                <span
                  className={styles.item}
                  key={`cart-gift-line-item-option-${option.name}-${option.value}`}
                >
                  {option.value}
                </span>
              ))}
            </span>
          )}
        </>
      </Text>
    </div>
  );
};

export const CartItemSelectedOptionsView = memo(
  CartItemSelectedOptionsViewBase
);
